import React, { useMemo } from 'react';
import { ModuleType } from 'infrastructure/enums';
import BaseTabs from 'components/atoms/base-tabs';

import s from './styles.module.scss';

import type { IBaseTab, IBaseTabsProps } from 'components/atoms/base-tabs';

interface IProps extends Omit<IBaseTabsProps<ModuleType>, 'tabs'> {
  rpmDisabled?: boolean;
  ccmDisabled?: boolean;
  apcmDisabled?: boolean;
  showApcm?: boolean;
}

const ModuleTabs: React.FC<IProps> = (props) => {
  const {
    activeKey,
    type = 'rounded',
    size = 'small',
    onChange,
    className,
    rpmDisabled = false,
    ccmDisabled = false,
    apcmDisabled = false,
    showApcm = false,
  } = props;

  const mappedTabs = useMemo<IBaseTab<ModuleType>[]>(() => {
    return [
      {
        key: ModuleType.RPM,
        label: ModuleType.RPM,
        disabled: rpmDisabled,
        className: s.tab,
        render: true,
      },
      {
        key: ModuleType.CCM,
        label: ModuleType.CCM,
        disabled: ccmDisabled,
        className: s.tab,
        render: true,
      },
      {
        key: ModuleType.APCM,
        label: ModuleType.APCM,
        disabled: apcmDisabled,
        className: s.tab,
        render: showApcm,
      },
    ].filter((tab) => tab.render !== false);
  }, [rpmDisabled, ccmDisabled, apcmDisabled, showApcm]);

  return (
    <BaseTabs
      activeKey={activeKey}
      tabs={mappedTabs}
      className={className}
      type={type}
      size={size}
      onChange={onChange}
    />
  );
};

export default ModuleTabs;
